import { useCallback, useRef } from 'react'

// ERP dialogs are controlled externally and usually have no Radix Trigger.
// Preserve their real opener before Radix moves focus into the portal.
export function useDialogFocusRestore() {
  const opener = useRef<HTMLElement | null>(null)
  const onOpenAutoFocus = useCallback(() => {
    const active = document.activeElement
    opener.current = active instanceof HTMLElement && active !== document.body ? active : null
  }, [])
  const onCloseAutoFocus = useCallback((event: Event) => {
    const target = opener.current
    opener.current = null
    // A removed opener or one hidden by another dialog cannot receive focus.
    if (!target?.isConnected || target.matches(':disabled') || target.closest('[inert],[aria-hidden="true"]')) return
    event.preventDefault()
    target.focus({ preventScroll: true })
  }, [])
  return { onOpenAutoFocus, onCloseAutoFocus }
}
